import React, { useContext, useEffect, useRef } from "react";
import "./Header.css";
import { useLocation, useNavigate } from "react-router-dom";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";

function Header() {
  const location = useLocation();
  const currentPath = location.pathname;

  const { setSignin } = useContext(Context);
  const navigate = useNavigate();

  // Header container reference
  const containerRef = useRef(null);

  const yello_links = [
    { path: "/manage-my-points", label: "Manage My Points" },
    { path: "/child-registration", label: "Child Registration" },
    { path: "/change-password", label: "Change Password" },
    { path: "/change-pin", label: "PIN" },
    { path: "/update-profile", label: "Update Profile" },
    { path: "/draw-details", label: "Draw Details" },
    { path: "", label: "Download Patch" },
    { path: "", label: "Play Games" },
    { path: "/change-pin-password", label: "PIN & Password" },
  ];

  const handleLogout = async () => {
    Cookies.remove("fun_ref_admin_security");
    await setSignin(false);
    navigate("/");
  };

  // Responsive scale
  const handleScale = () => {
    if (!containerRef.current) return;

    const baseWidth = 1060;
    const windowWidth = window.innerWidth;

    if (windowWidth < baseWidth) {
      const scaleFactor = windowWidth / baseWidth;

      // Modern browsers
      if ("zoom" in containerRef.current.style) {
        containerRef.current.style.zoom = scaleFactor;
        containerRef.current.style.transform = "none";
        containerRef.current.style.width = "100%";
      } else {
        // Fallback
        containerRef.current.style.transform = `scale(${scaleFactor})`;
        containerRef.current.style.transformOrigin = "top left";
        containerRef.current.style.width = `${baseWidth}px`;
      }
    } else {
      containerRef.current.style.zoom = "1";
      containerRef.current.style.transform = "none";
      containerRef.current.style.width = "100%";
    }
  };

  useEffect(() => {
    handleScale();

    window.addEventListener("resize", handleScale);

    return () => {
      window.removeEventListener("resize", handleScale);
    };
  }, []);

  return (
    <section className="Header">
      <div className="container-fluid p-0">
        <div
          className="header_container"
          ref={containerRef}
        >
          <div className="black_strip"></div>

          <div className="red_strip">
            <ul>
              <li>
                <a href="">About Us</a>
              </li>{" "}
              |
              <li>
                <a href="">MGM</a>
              </li>{" "}
              |
              <li>
                <a href="">Tutorials</a>
              </li>{" "}
              |
              <li>
                <a href="">FAQ's</a>
              </li>{" "}
              |
              <li>
                <a href="">Downloads</a>
              </li>{" "}
              |
              <li>
                <a href="">Contact Us</a>
              </li>
            </ul>
          </div>

          <div className="yellow_strip">
            <ul>
                                   
                                 
                
              {yello_links.map((link, index) => (
                <React.Fragment key={index}>
                  <li>
                    <a
                      href={link.path}
                      className={
                        link.path === currentPath ? "active" : ""
                      }
                    >
                      {link.label}
                    </a>
                  </li>

                  {index < yello_links.length - 1 && " | "}
                </React.Fragment>
              ))}

              {" | "}

              <li>
                <a
                  onClick={handleLogout}
                  style={{
                    cursor: "pointer",
                  }}
                >
                  Logout
                </a>
              </li>
              
                                   
                                 
                
            </ul>
          </div>

          <div className="left_img_div">
            <img
              src="/assets/login/logo.png"
              className="left_img"
              alt="Logo"
            />
          </div>
        </div>
      </div>
    </section>
  );
}

export default Header;